export default "__VITE_ASSET__BNH8mJ9Q__"